import { render, staticRenderFns } from "./purchaserArchives.vue?vue&type=template&id=6bc45179&scoped=true"
import script from "./purchaserArchives.vue?vue&type=script&lang=js"
export * from "./purchaserArchives.vue?vue&type=script&lang=js"
import style0 from "./purchaserArchives.vue?vue&type=style&index=0&id=6bc45179&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc45179",
  null
  
)

export default component.exports